import { isAxiosError } from 'axios';
import { apiClient } from '@/axios';
import { Endpoints } from '@/enums';
import { DocumentoSeleccionado } from '@/types/getPendingPaymentsType';
import { checkOpenedSettlement } from './checkOpenedSettlements';

type SaveSelectionResponse = {
  value: number;
};

type SaveSelectionParams = {
  codCliente: number;
  documents: DocumentoSeleccionado[];
  rut: string;
  razonSocial: string;
  referencia: string;
  retencionTitular: boolean;
  vencimiento: Date;
};

export const saveSelection = async (
  query: SaveSelectionParams
): Promise<SaveSelectionResponse['value']> => {
  const { documents, ...rest } = query;
  const oidDocumento = documents.map((item) => item?.oidDocumento || 0);

  try {
    const hasSelection = documents.filter((item) => !!item?.seleccion);

    if (hasSelection.length) {
      throw new Error('itemHasSelectionError', {
        cause: hasSelection.map((item) => item?.nroDoca).join(','),
      });
    }

    const total = documents.reduce(
      (acc, item) => acc + (item?.impMovMo || 0),
      0
    );

    if (!total) {
      throw new Error('selectionAmountFail');
    }

    const promises = documents.map(checkOpenedSettlement);

    await Promise.all(promises);

    const res = await apiClient.post<SaveSelectionResponse>(
      Endpoints.SaveSelection,
      {
        ...rest,
        oidDocumento,
      }
    );

    return res?.data?.value;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new Error(error.message);
    }
    throw error;
  }
};
